import messageService from "@/CommonDP/service/message-service";
import projectMgService from "@/CommonDP/service/project-service.js";
import { getCatalogToken, setCatalogToken } from "@/CommonDP/utils/auth";
import { storage } from "@/CommonDP/utils";
import Vue from "vue";
import XtDesignService from "../service/XtDesign-service";

// feat:实现一个模块内阻止项目切换
// key:vm  value: fn<promise>
const fnSet = new Set();
/**
 * @description 注册项目切换阻拦方法,同时返回一个方法用来注销阻拦
 * @param {()=>Promise|Promise} fn 阻拦方法
 * @param {Vue?} vm  注册的vue实例,当前vue卸载时,会同步移除
 * @returns {Function} 注销阻拦方法
 */
export function beforePrjId(fn, vm) {
  fnSet.add(fn);
  function unbind() {
    fnSet.delete(fn);
  }
  if (vm instanceof Vue) {
    vm.$on('hook:destroyed', unbind);
  }
  return unbind;
}
// 实际阻隔项目切换
async function waitPrjTask(to, from) {
  try {
    for (const fn of fnSet) {
      await (fn instanceof Function ? fn(to, from) : fn);
    }
  } catch (error) {
    throw new Error(error);
  }
}

function getObjectFromSessionStorage(name) {
  const json = storage.get(name);
  return json ? JSON.parse(json) : {};
}
function getisShowMyEnterprise(name) {
  return storage.get(name);
}
/**
 * @type {import("vuex").Module}
 */
const ProjectMg = {
  state: {
    prjObj: getObjectFromSessionStorage("updatePrjObjcook"),
    prjId: storage.get("updatePrjcook"),
    isShowNav: false,
    gantt: null, //
    unreadNum: 0, // 未读消息
    catalogInit: getCatalogToken(),
    processObj: {},
    routerParams: getObjectFromSessionStorage("routerParams"), // 路由跳转存值
    isShowMyEnterprise: getisShowMyEnterprise("isShowMyEnterprise"), // 是否展示企业信息
    delPersonKey: [],
    ideaTypeKey: "",
    hisOptions: [], // 最近访问项目
    myProjectsChange: false, // 我的项目权限改变
    checkSave: storage.get("checkSave")
  },
  getters: {
    allPrjList(state) { }
  },
  mutations: {
    UPDATE_PRJ(state, data) {
      state.prjObj = data;
      state.prjId = data.prjId || "";
      storage.set("updatePrjcook", data.prjId || "");
      storage.set("updatePrjObjcook", data ? JSON.stringify(data) : "");
    },
    UPDATE_IS_SHOW_NAV(state, data) {
      state.isShowNav = data;
    },
    UPDATE_GANTT(state, data) {
      state.gantt = data;
    },
    unreadNumber(state, num) {
      state.unreadNum = num || 0;
    },
    setCatalogToken(state, token) {
      state.catalogInit = token;
      setCatalogToken(token);
    },
    SET_PROCESS_OBJ(state, data) {
      state.processObj = data;
    },
    SET_ROUTER_PARAMS(state, data) {
      state.routerParams = data;
      storage.set("routerParams", data ? JSON.stringify(data) : "");
    },
    SET_ISSHOW_MYENTERPRISE(state, data) {
      state.isShowMyEnterprise = data;
      storage.set("isShowMyEnterprise", data);
    },
    SET_DEL_PERSON_KEY(state, data) {
      state.delPersonKey = data;
    },
    SET_IDEA_TYPE_KEY(state, data) {
      state.ideaTypeKey = data;
    },
    SET_HIS_OPTIONS(state, data) {
      state.hisOptions = data || [];
    },
    MY_PROJECTS_CHANGE(state) {
      state.myProjectsChange = !state.myProjectsChange;
    },
    SET_CHECK_SAVE(state, data) {
      state.checkSave = data;
      storage.set("checkSave", data);
    }
  },

  actions: {
    // 自动获取项目id
    async enterDefaultPrj({ rootState, dispatch }) {
      const { enterprise: { enterpriseId }} = rootState;
      for (const getList of [
        () => XtDesignService.getUserVisitHistory({
          enterpriseId,
          businessType: "prj",
          clientType: "web"
        })
      ]) {
        const { data: list } = await getList();
        if (list && list[0]) {
          await dispatch('updatePrj', list[0], false);
          break;
        }
      }
    },
    setIdeaTypeKey({ commit }, data) {
      commit("SET_IDEA_TYPE_KEY", data);
    },
    setDelPersonKey({ commit }, data) {
      commit("SET_DEL_PERSON_KEY", data);
    },
    setCatalogToken({ commit }, data) {
      commit("setCatalogToken", data);
    },
    async updatePrj({ commit, state, dispatch }, data = {}, useWait = true) {
      const prjId = data?.prjId;
      // 是否显示切换提示
      useWait && await waitPrjTask(state.prjId, prjId);
      // 实际切换数据
      if (prjId) {
        state.prjId !== prjId && dispatch("XtDesignUpdateNav", []);
        // 判端是不是当前人项目
        const { data: prjObj } = await projectMgService.tryGetProjectDetail({ prjId: data.prjId });
        if (prjObj) {
          await dispatch('getModuleProjectList', prjObj.prjId);
          commit("UPDATE_PRJ", prjObj);
        } else {
          dispatch('enterDefaultPrj');
        }
      } else {
        commit("UPDATE_PRJ", {});
      }
    },
    updateIsShowNav({ commit }, data) {
      commit("UPDATE_IS_SHOW_NAV", data);
    },
    async unreadNum({ commit }) {
      const store = require("@/store/index").default;
      const enterpriseId = store.state.enterprise.enterpriseId;
      const unauthorized = store.state.enterprise.unauthorized;
      if (enterpriseId && unauthorized === 1) {
        const res = await messageService.getUnReadNum(enterpriseId);
        commit("unreadNumber", res.data);
      }
    },

    // 存放表单的值
    setProcessObj({ commit }, data) {
      commit("SET_PROCESS_OBJ", data);
    },
    setRouterParams({ commit }, data) {
      commit("SET_ROUTER_PARAMS", data);
    },
    setIsShowMyEnterprise({ commit }, data) {
      commit("SET_ISSHOW_MYENTERPRISE", data);
    },
    // 设置最近访问项目
    setHisOptions({ commit }, data) {
      commit('SET_HIS_OPTIONS', data);
    },
    myProjectsChange({ commit }) {
      commit("MY_PROJECTS_CHANGE");
    },
    setCheckSave({ commit }, data) {
      commit("SET_CHECK_SAVE", data);
    }
  }
};

export default ProjectMg;
